import baselineCheckoutRoutes from '@/pages/baseline/checkout/routes'
import baselineOnboardingRoutes from '@/pages/baseline/onboarding/routes'
import type { ABTestRouteConfig } from '@app-studio-web/ui/types/abtest'

interface RouteDefinition {
  path?: string
  children?: RouteDefinition[]
}

function extractChildPaths(routesDef: RouteDefinition[]): string[] {
  const parent = routesDef[0]
  if (!parent || !parent.children) return []
  return parent.children.map((child) => child.path as string)
}

const baselineOnboardingOrder = extractChildPaths(
  baselineOnboardingRoutes as RouteDefinition[],
)
const baselineCheckoutOrder = extractChildPaths(
  baselineCheckoutRoutes as RouteDefinition[],
)

export const acriOnboardingABTestRouteConfig: ABTestRouteConfig = {
  baseline: baselineOnboardingOrder,
  variants: {},
}

export const acriCheckoutABTestRouteConfig: ABTestRouteConfig = {
  baseline: baselineCheckoutOrder,
  variants: {},
}

export function getABTestConfig() {
  const clientSecret = import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string
  const flagName =
    (import.meta.env.VITE_CONFIDENCE_FLAG_NAME as string) ||
    'acri-onboarding-variant'

  if (!clientSecret) {
    return null
  }

  return {
    clientSecret,
    flagName,
    defaultVariant: 'baseline',
    enabledVariants: ['baseline'],
  }
}
